<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>

<template>
    <TruckCards/>
</template>

<script>
import TruckCards from "@/components/scenarios/iiot/TruckCards.vue";
  export default {
    name: "Trucks",
    components: { 
      TruckCards
     },
  }
</script>